import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  orangeCardHeader,
  redCardHeader,
  yellowCardHeader,
  greenCardHeader,
  primaryCardHeader,
  roseCardHeader,
} from 'assets/jss/material-dashboard-react.jsx'
const cardHeaderStyle = {
  cardHeader: {
    padding: '0.75rem 1.25rem',
    marginBottom: '0',
    borderBottom: 'none',
    background: 'transparent',
    zIndex: '3 !important',
    '&$cardHeaderPlain,&$cardHeaderIcon,&$cardHeaderStats,&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$orangeCardHeader,&$redCardHeader,&$yellowCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader':
      {
        margin: '0 15px',
        padding: '0',
        position: 'relative',
        color: '#FFFFFF',
      },
    '&$yellowCardHeader': {
      margin: '0 15px',
      padding: '0',
      position: 'relative',
      color: '#000000',
    },
    '&:first-child': {
      borderRadius: 'calc(.25rem - 1px) calc(.25rem - 1px) 0 0',
    },
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$orangeCardHeader,&$redCardHeader,&$yellowCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader':
      {
        '&:not($cardHeaderIcon)': {
          borderRadius: '3px',
          marginTop: '-20px',
          padding: '15px',
        },
      },
    '&$cardHeaderStats svg': {
      fontSize: '36px',
      lineHeight: '56px',
      textAlign: 'center',
      width: '36px',
      height: '36px',
      margin: '10px 10px 4px',
    },
    '&$cardHeaderStats i': {
      fontSize: '36px',
      lineHeight: '56px',
      width: '56px',
      height: '56px',
      textAlign: 'center',
    },
    '&$cardHeaderStats$cardHeaderIcon': {
      textAlign: 'right',
    },
  },
  cardHeaderPlain: {
    marginLeft: '0px !important',
    marginRight: '0px !important',
  },
  cardHeaderStats: {
    '& $cardHeaderIcon': {
      textAlign: 'right',
    },
    '& h1,& h2,& h3,& h4,& h5,& h6': {
      margin: '0 !important',
    },
  },
  cardHeaderIcon: {
    '&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$greenCardHeader,&$orangeCardHeader,&$redCardHeader,&$yellowCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader':
      {
        background: 'transparent',
        boxShadow: 'none',
      },
    '& i': {
      width: '33px',
      height: '33px',
      textAlign: 'center',
      lineHeight: '33px',
    },
    '& svg': {
      width: '24px',
      height: '24px',
      textAlign: 'center',
      lineHeight: '33px',
      margin: '5px 4px 0px',
    },
  },
  warningCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...warningCardHeader,
    },
  },
  successCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...successCardHeader,
    },
  },
  dangerCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...dangerCardHeader,
    },
  },
  infoCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...infoCardHeader,
    },
  },
  orangeCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...orangeCardHeader,
    },
  },
  redCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...redCardHeader,
    },
  },
  yellowCardHeader: {
    color: '#000000',
    '&:not($cardHeaderIcon)': {
      ...yellowCardHeader,
    },
  },
  greenCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...greenCardHeader,
    },
  },
  primaryCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...primaryCardHeader,
    },
  },
  roseCardHeader: {
    color: '#FFFFFF',
    '&:not($cardHeaderIcon)': {
      ...roseCardHeader,
    },
  },
}

export default cardHeaderStyle
